import { DatasetDurationLimiter } from "@/services/license/license-limiters/base-limiters/dataset-duration-limiter";
import { LicenseName } from "@/data/license.data";
import { IsDatasetLimitedResult } from "@/services/license/base/license-manager-abstractions";

export abstract class DefaultDatasetDurationLimiter extends DatasetDurationLimiter {
  private trialFileDurationMinutesLimit = 6;
  private paidFileDurationMinutesLimit = 10;

  getPlanLimit(license: LicenseName): number {
    switch (license) {
      case "Trial":
        return this.trialFileDurationMinutesLimit;
      default:
        return this.paidFileDurationMinutesLimit;
    }
  }

  async isDatasetDurationLimited(
    userId: string,
    license: LicenseName,
    seconds: number,
  ): Promise<IsDatasetLimitedResult> {
    const limit = await this.getLimit(userId, license);
    return { isLimited: seconds >= limit * 60, limit: limit };
  }
}
